var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "rsp2CurrentNews", attrs: { id: "aktuelles" } },
    [
      _c("h2", [_vm._v("Aktuelles für Beschäftigte")]),
      _vm._v(" "),
      _vm.topItem
        ? _c(
            "article",
            {
              class: {
                rsp2TopNews: true,
                rsp2Hatching:
                  _vm.topItem.majorVersion % 1 !== 0 || !_vm.topItem.public
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "rsp2ImageContainer",
                  attrs: { href: _vm.topItem.url }
                },
                [
                  _c("img", {
                    staticClass: "rsp2Image",
                    attrs: {
                      src: _vm.topItem.imageUrl,
                      alt: _vm.topItem.imageAlt
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rsp2ContentContainer" }, [
                _c("h3", [
                  _c("span", { staticClass: "rsp2Category" }, [
                    _vm._v(_vm._s(_vm.topItem.header))
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "rsp2Title",
                      attrs: { href: _vm.topItem.url }
                    },
                    [_vm._v(_vm._s(_vm.topItem.title))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rsp2Metadata" }, [
                  _vm._v(
                    "\n\t\t\t\tVon\n\t\t\t\t" +
                      _vm._s(_vm._f("fullName")(_vm.topItem.author)) +
                      "\n\t\t\t\t" +
                      _vm._s(
                        _vm._f("prepend")(
                          _vm._f("formatDate")(_vm.topItem.date),
                          " am"
                        )
                      ) +
                      "\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "rsp2Text" }, [
                  _vm._v(_vm._s(_vm.topItem.teaser))
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rsp2News" },
        [
          _vm._l(_vm.newsItems, function(newsItem) {
            return [
              _c("CurrentNewsItem", {
                key: newsItem.id,
                attrs: {
                  url: newsItem.url,
                  title: newsItem.title,
                  author: newsItem.author,
                  icon: newsItem.icon,
                  date: newsItem.date,
                  category: newsItem.header,
                  hatching: newsItem.majorVersion % 1 !== 0 || !newsItem.public
                }
              })
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }